import { type SectionConfig } from '@/utils/get-matched-section'

export const sectionConfig: SectionConfig = {
  '/logistics/board': {
    title: 'Testing Board',
    showBreadcrumbs: false
  },
  '/logistics/scan': {
    title: 'Scan Station'
  },
  '/logistics/assets': {
    title: 'Assets'
  },
  '/logistics/assets/[serial]': {
    title: (params) => {
      const p = params as { serial?: string }
      return p?.serial ? decodeURIComponent(p.serial) : 'Asset'
    },
    parentBreadcrumb: {
      label: 'Assets',
      href: (_params, orgSlug) => `/${orgSlug}/logistics/assets`
    }
  },
  '/logistics/catalogs/models': {
    title: 'Device Models'
  },
  '/logistics/catalogs/fault-codes': {
    title: 'Fault Codes'
  },
  '/logistics/catalogs/test-profiles': {
    title: 'Test Profiles'
  },
  '/logistics/catalogs/software-versions': {
    title: 'Software Versions'
  },
  '/logistics/reports/recidivism': {
    title: 'Recidivism Report'
  },
  '/logistics/import': {
    title: 'Import Assets'
  },
  '/logistics/shipping/[kind]': {
    title: (params) => {
      const p = params as { kind?: string }
      return p?.kind === 'support' ? 'Support Shipments' : 'Project Shipments'
    },
    showBreadcrumbs: false
  },
  '/logistics/shipping/[kind]/[orderNo]': {
    title: (params) => {
      const p = params as { orderNo?: string }
      return p?.orderNo ? decodeURIComponent(p.orderNo) : 'Order'
    },
    parentBreadcrumb: {
      label: (params) => {
        const p = params as { kind?: string }
        return p?.kind === 'support' ? 'Support Shipments' : 'Project Shipments'
      },
      href: (params, orgSlug) => {
        const p = params as { kind?: string }
        return `/${orgSlug}/logistics/shipping/${p?.kind ?? 'project'}`
      }
    }
  },
  '/logistics/shipping/in-flight': {
    title: 'In Flight',
    showBreadcrumbs: false
  },
  '/logistics/posted/[kind]': {
    title: (params) => {
      const p = params as { kind?: string }
      return p?.kind === 'support'
        ? 'Posted Support Shipments'
        : 'Posted Project Shipments'
    },
    showBreadcrumbs: false
  },
  '/logistics/inventory': {
    title: 'Stock on Hand',
    showBreadcrumbs: false
  },
  '/logistics/receiving': {
    title: 'Receiving',
    showBreadcrumbs: false
  },
  '/logistics/procurement': {
    title: 'Purchase Orders',
    showBreadcrumbs: false
  },
  '/logistics/procurement/[orderNo]': {
    title: (params) => {
      const p = params as { orderNo?: string }
      return p?.orderNo ? decodeURIComponent(p.orderNo) : 'Purchase Order'
    },
    parentBreadcrumb: {
      label: 'Purchase Orders',
      href: (_params, orgSlug) => `/${orgSlug}/logistics/procurement`
    }
  }
}
